import { rgba } from 'polished';

export const WHITE = '#FFFFFF';
export const WHITE__TRANSLUCENT = rgba(WHITE, 0.9);

export const GREY = '#AAAAAA';

export const BLACK = '#000000';
